import React from 'react';
import styles from './RegisterSuccess.module.scss';
import { store } from '../../../redux/configureStore';
import { resetForm } from 'components/wizard/container/actions';
import logoImage from 'images/logo-25.svg';

function RegisterSuccess(props) {
  /* If the user reaches this "Thank You" page, assume it is safe to
   * "clear" the form data. If the user re-enters the wizard, the form
   * should be reset.
   *
   * Alternatively the <Link /> allows users to manually reset the form.
   */
  setTimeout(() => {
    store.dispatch(resetForm(undefined)); // Reset state
  }, 3000); // Arbitrary timeout value set
  console.log(props);

  return (
    <div className={styles.wrapper}>
      <div id={styles["logoContainer"]} className="container-fluid">
        <img src={logoImage} alt="BTIS Inc. Logo" />
      </div>
      <div id={styles["mainContent"]} className="container-fluid d-flex flex-column justify-content-center">
        <h1 className="mx-5">Thank You!</h1>
        {!props.registerData.NIPRRecord ? (
          <div className="m-5">
            <p>
              Your registration has been received and will be processed within 4
              business hours. You will receive an email via EchoSign to complete your registration process.
            </p>
            <p>
              Please call us at{' '}
              <a href="tel:877-649-6682">877.649.6682</a> or email{' '}
              <a href="mailto:register@btisinc.com">register@btisinc.com</a> with
              questions, comments or concerns!
            </p>
          </div>
        ) :
          <div className="m-5">
            <p>
              In order to complete your registration process,
              documents have been emailed via EchoSign to {props.registerData.PrincipalEmail}.
              Once signed, you will receive your agency code and password via email.
            </p>
            <p>
              Please call us at{' '}
              <a href="tel:877-649-6682">877.649.6682</a> or email{' '}
              <a href="mailto:register@btisinc.com">register@btisinc.com</a> with
              questions, comments or concerns!
            </p>
          </div>
        }
      </div>
    </div>
  );
}

export default RegisterSuccess;
